<template lang='pug'>
  nav.sidebar(aria-role="nav")
    ul
      li(v-if="isDashboardUser")
        router-link(to="/dashboard" exact title="Dashboard" aria-label="dashboard")
          svg#dashboard.svgicon(data-name='dashboard', xmlns='http://www.w3.org/2000/svg', viewbox='0 0 32 32')
            title Dashboard
            path(d='M31.82,15.12a.35.35,0,0,1,.18.29.63.63,0,0,1-.12.35l-1.18,1.47a.55.55,0,0,1-.32.15.36.36,0,0,1-.32-.09l-.88-.71V28.24a.91.91,0,0,1-.94.94H18.35a.51.51,0,0,1-.47-.47V21.18H14.12v7.53a.51.51,0,0,1-.47.47H3.76a.91.91,0,0,1-.94-.94V16.59l-.88.71a.36.36,0,0,1-.32.09.55.55,0,0,1-.32-.15L.12,15.76A.63.63,0,0,1,0,15.41a.35.35,0,0,1,.18-.29L14.53,3.35a2.31,2.31,0,0,1,2.94,0l8.88,7.24V7.06a.51.51,0,0,1,.47-.47h1.88a.51.51,0,0,1,.47.47v5.88ZM26.35,26.35V14.24L16.29,6a.43.43,0,0,0-.59,0L5.65,14.24V26.35h5.65V18.82a.51.51,0,0,1,.47-.47h8.47a.51.51,0,0,1,.47.47v7.53Z')
      li(v-if="isDashboardUser")
        router-link(to="/report" exact title="Report" aria-label="report")
          svg#reports.svgicon(data-name='reports', xmlns='http://www.w3.org/2000/svg', viewbox='0 0 32 32')
            title Report
            path(d='M31.78,25.22a.72.72,0,0,1,.22.53v1.5a.75.75,0,0,1-.75.75H.75a.72.72,0,0,1-.53-.22A.72.72,0,0,1,0,27.25V4.75a.72.72,0,0,1,.22-.53A.72.72,0,0,1,.75,4h1.5A.75.75,0,0,1,3,4.75V25H31.25A.72.72,0,0,1,31.78,25.22ZM9,16.75A.75.75,0,0,0,8.25,16H6.75a.75.75,0,0,0-.75.75v4.5a.75.75,0,0,0,.75.75h1.5A.75.75,0,0,0,9,21.25Zm6-8A.75.75,0,0,0,14.25,8h-1.5a.75.75,0,0,0-.75.75v12.5a.75.75,0,0,0,.75.75h1.5a.75.75,0,0,0,.75-.75Zm6,4a.75.75,0,0,0-.75-.75h-1.5a.75.75,0,0,0-.75.75v8.5a.75.75,0,0,0,.75.75h1.5a.75.75,0,0,0,.75-.75Zm6-6A.75.75,0,0,0,26.25,6h-1.5a.75.75,0,0,0-.75.75v14.5a.75.75,0,0,0,.75.75h1.5a.75.75,0,0,0,.75-.75Z')
      li(v-if="isCoach")
        router-link(to="/coaching" exact title="Coaching" aria-label="coaching")
          svg#reports.svgicon(data-name='reports', xmlns='http://www.w3.org/2000/svg', viewbox='0 0 32 32')
            title coaching
            path(d='M20.49,5.13A11.64,11.64,0,0,1,25,8.79a8,8,0,0,1,1.64,4.71,7.47,7.47,0,0,1-1,3.74,10.86,10.86,0,0,1-2.8,3.19,13.56,13.56,0,0,1-4.1,2.16,16.91,16.91,0,0,1-5.38.83A17.16,17.16,0,0,1,9.4,23a14.36,14.36,0,0,1-6.71,1.89A2.57,2.57,0,0,1,1,24.29a2.68,2.68,0,0,1-.94-1.47A2.51,2.51,0,0,1,.25,21.1a2.72,2.72,0,0,1,1.22-1.28,4.18,4.18,0,0,0,1-.61,13,13,0,0,1-1.11-1.39A8,8,0,0,1,0,13.42,7.86,7.86,0,0,1,1.66,8.79,11.64,11.64,0,0,1,6.18,5.13a16,16,0,0,1,7.16-1.55A16,16,0,0,1,20.49,5.13ZM7.57,7.4a9.43,9.43,0,0,0-3.66,2.77A5.61,5.61,0,0,0,2.69,13.5a5.28,5.28,0,0,0,.89,2.88,8.58,8.58,0,0,0,2.16,2.16,5,5,0,0,1-3.05,3.66A12.31,12.31,0,0,0,9,20.1a13.94,13.94,0,0,0,4.33.67,13.74,13.74,0,0,0,5.77-1.16,9.43,9.43,0,0,0,3.66-2.77A5.61,5.61,0,0,0,24,13.5a5.61,5.61,0,0,0-1.22-3.33A9.43,9.43,0,0,0,19.11,7.4a13.74,13.74,0,0,0-5.77-1.16A13.74,13.74,0,0,0,7.57,7.4ZM30.92,27.87a2.57,2.57,0,0,1-1.61.55,11.49,11.49,0,0,1-5.66-1.66,15,15,0,0,1-4.47.33A12.76,12.76,0,0,1,14.89,26a19.14,19.14,0,0,0,6.43-1.61,12.61,12.61,0,0,0,2.72-.5,10,10,0,0,0,5.27,1.83,4.37,4.37,0,0,1-2.55-3.27,7.1,7.1,0,0,0,1.77-1.89A5,5,0,0,0,29.31,18a4.4,4.4,0,0,0-.39-1.77,9.11,9.11,0,0,0,.28-4.1,9.5,9.5,0,0,1,2.05,2.8A7.14,7.14,0,0,1,32,18,7.59,7.59,0,0,1,30,23a2.1,2.1,0,0,0,.55.39,2.79,2.79,0,0,1,1.16,1.28,2.51,2.51,0,0,1,.17,1.72A2.85,2.85,0,0,1,30.92,27.87Z')
      li(v-if="isCoach")
        router-link(to="/coaching-canned-response-manager" exact title="Coaching canned responses" aria-label="Coaching canned responses")
          svg.svgicon(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 512 512')
            path(d='M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288zM336 184h-56v-56c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v56h-56c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h56v56c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-56h56c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z')

</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'TheSidebar',
  computed: {
    ...mapGetters([
      'isDashboardUser',
      'isCoach',
      'isCoachSupervisor'
    ])
  }
};
</script>

<style lang="scss" scoped>
  .sidebar {
    @include position(fixed, $header-height 0 null 0);
    z-index: 1;
    width: $sidebar-width;
    height: 100%;
    padding: $base-spacing $small-spacing;
    background: $dark-color;
    color: #fff;
    overflow-y: auto;
  }
  ul {
    display: block;
    @include zero;
  }
  li {
    display: block;
    margin-bottom: $base-spacing;
  }
  a {
    color: #fff;
    display: block;
    text-align: center;
  }
  a:hover, a:focus, .router-link-active {
    color: $light-link;
  }
  .svgicon {
    @include size(32px);
    margin: 0 auto;
  }
</style>
